import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LeftMenuSidebar from "../../../unicomponents/LeftMenuSidebar";
import CertificateManagement from "./components/CertificateManagement";

export default function GemeralManagement() {
  const { t } = useTranslation();

  const [activeMenu, setActiveMenu] = useState({
    menu_name: "certificate_management",
    menu_id: "certificate_management",
  });

  const menuData = [
    {
      item_name: "certificate_management",
      item_label:
        t("admin.generalManagement.certificateManagement") || "증명서발급이력",
    },
  ];

  // const [groupsQueryConditions, setGroupsQueryConditions] = useState({
  //   schoolid: schoolId,
  //   group_type: "teacher",
  // });

  // useEffect(() => {
  //   setGroupsQueryConditions((prev) => ({
  //     ...prev,
  //     group_type: activeMenu.menu_name,
  //   }));
  // }, [activeMenu]);

  return (
    <div className="basicWidth">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-2">
            <LeftMenuSidebar
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              menuData={menuData}
              // extraFunction={handleQueryCondition}
              itemName="item_name"
              itemLabel="item_label"
            />
          </div>
          <div className="col-12 col-md-10">
            <CertificateManagement />
          </div>
        </div>
      </div>
    </div>
  );
}
